module.exports = __webpack_public_path__ + "img/Hiyori.c1b64166.png";